<template>
  <header
    id="main-header"
    class="main-header">
    <nav aria-label="Website Navigation">
      <div class="logo">
        <a
          id="scroll-to-hero"
          href="/"
        >
          <img
            src="/images/humming-bird-big-trans-green2.png"
            alt="Portfolio Logo"
            height="100px"
          />
        </a>
      </div>
      <div class="nav-links">
        <ol>
          <li
            v-for="menu in mobileMenu"
            :key="menu.link">
            <router-link
              :id="'scroll-to-'+menu.link"
              :to="{ path: '/', hash: '#'+menu.link, }"
              class="hover-underline-animation"
            >
              {{ menu.label }}
            </router-link>
          </li>
        </ol>
        <div>
          <a
            :href="resumeLink"
            class="resume-button"
            target="_blank"
            rel="noopener noreferrer"
            title="Download CV in docx"
          >
            Resume
          </a>
        </div>
      </div>
      <div class="menu">
        <button
          id="toggle-mobile-menu"
          @click="toggleMobileMenu()">
          <div
            id="ham-box-menu"
            class="ham-box">
            <div class="ham-box-inner"></div>
          </div>
          <div
            id="close-menu"
            class="close-menu">
            <!-- <div class="close-menu-inner"></div> -->
            <i
              class="fa fa-times"
              style="font-size: 25px"></i>
          </div>
        </button>
        <aside
          v-if="showMobileMenu"
          id="mobile-menu"
          aria-hidden="false"
          tabindex="1"
          class="mobile-menu"
        >
          <nav aria-label="Mobile Navigation">
            <ol>
              <li
                v-for="menu in mobileMenu"
                :key="menu.link"
              >
                <a
                  :href="'#'+menu.link"
                  :class="(selectedSection === menu.link) ? 'selected' : null"
                  @click="toggleMobileMenu(menu.link,)"
                >
                  {{ menu.label }}
                </a>
              </li>
            </ol>
            <a
              :href="resumeLink"
              class="resume-link"
              target="_blank"
              rel="noopener noreferrer"
              title="Download CV in docx"
            >
              Resume
            </a>
          </nav>
        </aside>
      </div>
    </nav>
  </header>
</template>

<script>
import EventBus from '@/eventBus'

export default {
  name: 'PortfolioHeader',
  data () {
    return {
      showMobileMenu: false,
      selectedSection: '',
      resumeLink: '/pdf/Soumyadip-Hazra-Resume.docx',
      mobileMenu: [
        { link: 'about', label: 'About' },
        { link: 'jobs', label: 'Experience' },
        { link: 'projects', label: 'Work' },
        { link: 'contact', label: 'Contact' }
      ]
    }
  },
  methods: {
    scrollToSection (section) {
      if (section) {
        EventBus.$emit('scroll-to-section', section)
      }
    },
    toggleMobileMenu (section = null) {
      this.showMobileMenu = !this.showMobileMenu
      if (section) {
        this.selectedSection = section
      }
    }
  }
}
</script>

<style lang="scss">
@import "../../assets/scss/layout/_header.scss";
</style>
